import React, { useRef } from "react";
import PricingCard from "./PricingCard";
import "./PricingCards.css";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const pricingData = [
  {
    title: "Matematika - viša razina - 45 sati",
    description: "30 termina od 1,5 sunčani sat",
    times: "subota 10:00 - 11:30 h",
    teacher: "Marcella Vidmar, prof.",
    price: "335",
  },
  {
    title: "Matematika - osnovna razina – 45 sati",
    description: "30 termina od 1,5 sunčani sat",
    times: "četvrtak 20:30 – 22:00 h",
    teacher: "Mia Černivec, mag.educ.",
    price: "335",
  },
  {
    title: "Kemija – 42 sata",
    description: "28 termina od 1,5 sunčani sat",
    times: "četvrtak 20:30 – 22:00 h",
    teacher: "Vjekoslav Šinko, prof.",
    price: "314",
  },
  {
    title: "Kemija – 42 sata",
    description: "28 termina od 1,5 sunčani sat",
    times: "nedjelja 10:30 – 12:00 h",
    teacher: "Maria Juretić Mohorić, diplomirana biokemičarka",
    price: "314",
  },
  {
    title: "Fizika – 42 sata",
    description: "28 termina od 1,5 sunčani sat",
    times: "utorak 20:30-22:00 h",
    teacher: "Olja Bunčić, prof.",
    price: "314",
  },
  {
    title: "Hrvatski jezik - esej/sažetak – 18 sati",
    description: "12 termina od 1,5 sunčani sat",
    times: "ponedjeljak 20:30-22:00 h",
    teacher: "Marina Klobučar, prof.",
    price: "136",
  },
  {
    title: "Hrvatski jezik – 42 sata",
    description: "28 termina od 1,5 sunčani sat",
    times: "srijeda 20:30-22:00 h",
    teacher: "Marina Klobučar, prof.",
    price: "314",
  },
  {
    title: "Engleski jezik – 30 sati",
    description: "20 termina od 1,5 sunčani sat",
    times: "",
    teacher: "",
    price: "230",
  },
];

const PricingCards = () => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [isDragging, setIsDragging] = React.useState(false);
  const [startX, setStartX] = React.useState(0);
  const [scrollPosition, setScrollPosition] = React.useState(0);

  const onMouseDown = (e: React.MouseEvent) => {
    if (scrollRef.current) {
      e.preventDefault();
      setIsDragging(true);
      setStartX(e.pageX - scrollRef.current.offsetLeft);
      setScrollPosition(scrollRef.current.scrollLeft);
    }
  };

  const onMouseUp = () => {
    setIsDragging(false);
  };

  const onMouseMove = (e: React.MouseEvent) => {
    if (!isDragging || !scrollRef.current) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 2; // The 2 is a speed multiplier
    scrollRef.current.scrollLeft = scrollPosition - walk;
  };

  const onMouseLeave = () => {
    setIsDragging(false);
  };

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -200, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 200, behavior: "smooth" });
    }
  };

  return (
    <>
      <div className="d-flex align-items-center">
        <div>
          <IoIosArrowBack
            size={40}
            className="scroll-button"
            onClick={scrollLeft}
          />
        </div>

        <div
          ref={scrollRef}
          className={`pb-2 text-center d-flex overflow-x-scroll ${
            isDragging ? "grabbing unselectable" : ""
          }`}
          onMouseDown={onMouseDown}
          onMouseUp={onMouseUp}
          onMouseLeave={onMouseLeave}
          onMouseMove={onMouseMove}
        >
          {pricingData.map((pricingCard, index) => (
            <PricingCard
              title={pricingCard.title}
              description={pricingCard.description}
              price={pricingCard.price}
              times={pricingCard.times}
              teacher={pricingCard.teacher}
            />
          ))}
        </div>

        <div>
          <IoIosArrowForward
            size={40}
            className="scroll-button"
            onClick={scrollRight}
          />
        </div>
      </div>
      <p className="mx-5">
        <em>U cijenu je uračunat iznos PDV-a. Mogućnost plaćanja na rate.</em>
      </p>
    </>
  );
};

export default PricingCards;
